import { render, staticRenderFns } from "./ProposalListing.vue?vue&type=template&id=b2971224&"
import script from "./ProposalListing.vue?vue&type=script&lang=js&"
export * from "./ProposalListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports